import { requestJson } from './http';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

function authorization(): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface AccountProfile {
  id: string;
  email: string;
  username: string | null;
  full_name: string | null;
  is_active: boolean;
  is_premium: boolean;
  profile_picture_url: string | null;
}

export async function updateAccountName(fullName: string): Promise<AccountProfile> {
  return requestJson<AccountProfile>(`${API_BASE_URL}/auth/me`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authorization() },
    body: JSON.stringify({ full_name: fullName }),
  });
}

export async function updateAccountPicture(file: File): Promise<AccountProfile> {
  const body = new FormData();
  body.append('file', file);
  return requestJson<AccountProfile>(`${API_BASE_URL}/auth/me/profile-picture`, {
    method: 'POST',
    headers: authorization(),
    body,
  });
}
